import React, { useEffect, useState } from "react";

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if already in standalone mode
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (isStandalone) {
      return;
    }

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);

    window.addEventListener("appinstalled", () => {
      setIsInstallable(false);
      setDeferredPrompt(null);
      console.log("RiceQRCodes PWA installed successfully");
    });

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === "accepted") {
      console.log("User accepted PWA installation");
    }
    setDeferredPrompt(null);
    setIsInstallable(false);
  };

  if (!isInstallable || isDismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[99999] bg-gradient-to-r from-green-600 to-emerald-600 text-white p-4 rounded-xl shadow-2xl flex items-center gap-4 border border-green-400 print:hidden">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center p-1 shadow">
          <img
            src="/android-icon-96x96.png"
            alt="RiceQRCodes Logo"
            className="w-full h-full object-contain"
            onError={(e) => {
              e.target.src = "/favicon.ico";
            }}
          />
        </div>
        <div>
          <h4 className="font-bold text-sm leading-tight">Install RiceQRCodes App</h4>
          <p className="text-xs text-green-100">Faster access & mobile app</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={handleInstallClick}
          className="bg-white text-green-700 hover:bg-green-50 font-bold text-xs px-3 py-2 rounded-lg shadow transition-all duration-200 cursor-pointer"
        >
          Install
        </button>
        <button
          onClick={() => setIsDismissed(true)}
          className="text-green-200 hover:text-white p-1 text-sm font-bold cursor-pointer"
          title="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default InstallPWA;
